"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const constants_1 = require("./constants");
exports.getFilterCategoriesByTabName = tabName => {
  switch (tabName) {
    case constants_1.TAB_NAME.INSIGHTS:
      return [{ category: "Insights", subCategories: [] }];
    case constants_1.TAB_NAME.AUTO_REMEDIATION:
      return [{ category: "By Solution", subCategories: ["Remediation"] }];
    case constants_1.TAB_NAME.UTILISATION:
      return [{ category: "By Solution", subCategories: ["Reporting"] }];
    case constants_1.TAB_NAME.EVENTS:
      return [{ category: "Events", subCategories: [] }];
    case constants_1.TAB_NAME.INVENTORY:
      return [{ category: "Inventory", subCategories: [] }];
    case constants_1.TAB_NAME.INVENTORY_GLOBAL:
      return [{ category: "Inventory", subCategories: [] }];
    default:
      return [];
  }
};
exports.getTabNameByCategories = categories => {
  if (!categories || !categories.length) return "Invalid_Category";
  if (categories.find(x => x.category === "Insights")) {
    return constants_1.TAB_NAME.INSIGHTS;
  }
  if (
    categories.find(
      x =>
        x.category === "By Solution" &&
        x.subCategories.find(s => s === "Remediation")
    )
  ) {
    return constants_1.TAB_NAME.AUTO_REMEDIATION;
  }
  if (
    categories.find(
      x =>
        x.category === "By Solution" &&
        x.subCategories.find(s => s === "Reporting")
    )
  ) {
    return constants_1.TAB_NAME.UTILISATION;
  }
  if (categories.find(x => x.category === "Events")) {
    return constants_1.TAB_NAME.EVENTS;
  }
  if (categories.find(x => x.category === "Inventory")) {
    return constants_1.TAB_NAME.INVENTORY;
  }
  if (categories.find(x => x.category === "Custom")) {
    return constants_1.TAB_NAME.WORKFLOWS;
  }
  return "Invalid_Category";
};
exports.getExcludeFilterCategoriesByTabName = tabName => {
  switch (tabName) {
    case constants_1.TAB_NAME.WORKFLOWS:
      return [
        { category: "Insights", subCategories: [] },
        {
          category: "By Solution",
          subCategories: ["Remediation", "Reporting"]
        },
        { category: "Inventory", subCategories: [] }
      ];
    case constants_1.TAB_NAME.INSIGHTS:
      return [];
    default:
      return [];
  }
};
exports.getResourceName = action => {
  let indexOfFirstUpperCase = action
    .split("")
    .findIndex(x => x.toUpperCase() === x);
  if (indexOfFirstUpperCase === -1) return action;
  action = action.substring(indexOfFirstUpperCase);
  return action.split(/(?=[A-Z].)/).join(" ");
};
exports.filterItemsByCategory = (items, categoryItem) => {
  if (
    !categoryItem ||
    !categoryItem.category ||
    categoryItem.category.toLowerCase() === "all"
  ) {
    return items;
  }
  return items.filter(e => {
    if (!e.categories && (!e.properties || !e.properties.categories))
      return false;
    let itemCategories = e.categories || e.properties.categories || [];
    let cat = itemCategories.find(c => c.category === categoryItem.category);
    if (!cat) return false;
    if (!categoryItem.subCategories || !categoryItem.subCategories.length)
      return true;
    if (
      categoryItem.subCategories.length === 1 &&
      categoryItem.subCategories[0].toLowerCase() === "all"
    )
      return true;
    // Allow item if subCategories includes all
    if (cat.subCategories.includes("*")) return true;
    let sub = cat.subCategories.filter(
      x => categoryItem.subCategories.indexOf(x) !== -1
    );
    return sub.length > 0;
  });
};
exports.filterItemsByMultipleCategories = (items, categories) => {
  if (!categories || !categories.length) {
    return items;
  }
  for (let cat of categories) {
    // console.log("categries to filter", { cat });
    items = exports.filterItemsByCategory(items, cat);
    // console.log("items after category filter", items.length);
  }
  return items;
};
exports.filterItemsByExcludeCategory = (items, categories) => {
  if (!items || !categories || categories.length === 0) return items;
  // console.log(
  //     "filtering items by exclude category",
  //     JSON.stringify(categories, null, 2)
  // );
  return items.filter(e => {
    if (!e.categories && (!e.properties || !e.properties.categories))
      return false;
    let itemCategories = e.categories || e.properties.categories || [];
    let categoriesToExclude = categories.find(x => {
      let cat = itemCategories.find(c => c.category === x.category);
      if (!cat) return false;
      if (!x.subCategories || x.subCategories.length === 0) return true;
      let sub = cat.subCategories.filter(
        s => x.subCategories.indexOf(s) !== -1
      );
      return sub.length > 0;
    });
    return !categoriesToExclude;
  });
};
//# sourceMappingURL=filters.js.map
